import { Component, computed, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AdminButtonComponent, AdminCardComponent } from '../../../../shared/admin';
import { CreateFranchisePayload, FranchisesService } from '../../../../shared/services/franchises.service';
import { PermissionService } from '../../../permissions/permission.service';

@Component({
  selector: 'app-franchise-form-page',
  standalone: true,
  imports: [FormsModule, AdminCardComponent, AdminButtonComponent],
  templateUrl: './franchise-form-page.component.html',
  styleUrl: './franchise-form-page.component.scss',
})
export class FranchiseFormPageComponent {
  private readonly franchisesService = inject(FranchisesService);
  private readonly router = inject(Router);
  private readonly permissions = inject(PermissionService);

  readonly showCreate = computed(() => this.permissions.canShow('franchises', 'create'));
  readonly canCreate = computed(() => this.permissions.canExecute('franchises', 'create'));

  name = '';
  code = '';
  adminEmail = '';
  contactPhone = '';
  readonly saving = signal(false);
  readonly error = signal<string | null>(null);

  submit(): void {
    if (!this.canCreate()) return;
    const payload: CreateFranchisePayload = {
      name: this.name.trim(),
      code: this.code.trim().toUpperCase(),
      adminEmail: this.adminEmail.trim().toLowerCase(),
      contactPhone: this.contactPhone.trim() || undefined,
    };

    if (!payload.name || !payload.code || !payload.adminEmail) {
      this.error.set('Name, code, and admin email are required.');
      return;
    }

    this.saving.set(true);
    this.error.set(null);
    this.franchisesService.create(payload).subscribe({
      next: (data) => {
        this.saving.set(false);
        const franchiseId = data.franchise.franchiseId;
        void this.router.navigateByUrl(
          franchiseId ? `/platform/franchises/${franchiseId}` : '/platform/franchises',
        );
      },
      error: (err: { error?: { message?: string } }) => {
        this.saving.set(false);
        this.error.set(err.error?.message ?? 'Could not create franchise.');
      },
    });
  }

  cancel(): void {
    void this.router.navigateByUrl('/platform/franchises');
  }
}
